import { z } from '@harvestiq/zod';
import { zIsoDate } from '@harvestiq/zod';
import {
  HiqLrpTypeCodeNames,
  RmaLrpCommodityNames,
  RmaLgmCommodityNames,
} from '@harvestiq/constants';

export const getMarketingDatesRequestSchema = z.object({
  salesEffectiveDate: zIsoDate().optional(),
  commodity: z
    .nativeEnum(RmaLrpCommodityNames)
    .or(z.nativeEnum(RmaLgmCommodityNames)),
  commodityType: z.nativeEnum(HiqLrpTypeCodeNames),
});

export type GetMarketingDatesRequest = z.infer<
  typeof getMarketingDatesRequestSchema
>;

export const getMarketingDatesResponseSchema = z.object({
  data: z.array(zIsoDate()),
});

export type GetMarketingDatesResponse = z.infer<
  typeof getMarketingDatesResponseSchema
>;
